import { hashByValue } from './utils/helpers';

export const ILLUSTRATIONS = [
'illo-smallspot-catbird',
'illo-smallspot-catdog',
'illo-smallspot-catfish',
'illo-smallspot-cathorse',
'illo-smallspot-dograbbit',
] as const;

export type Illustration = (typeof ILLUSTRATIONS)[number];

export const getUserAgentIllustration = (value: string): Illustration =>
      ILLUSTRATIONS[hashByValue(value) % ILLUSTRATIONS.length];
